import React ,{useState}from 'react';
import moment from 'moment';
import { H4, ConfirmationBox } from '../../../components/index';
import Label from '../../../components/ncss/Label';
import { connect } from 'react-redux';
import { createServiceAction } from '../../../util/actionHelper.js';
const Remediation = ({qrfDetails, frfDetails, attachment, showTitle, isDownload, attachmentEdit,downloadAttachment}) => {
  const [submitModal, setSubmitModal] = useState(false);
  const [fileName, setFileName] = useState('');

    const openConfirmationPopup = (fileName)=> {
        setSubmitModal(true);
        setFileName(fileName);
        }
    
    const  downloadFile = (requestParams) =>{
        downloadAttachment({ ...requestParams, formType:'frf'});
      }
    
    const closeSubmitModal = () => {
        setSubmitModal(false);
      };
    return (
        (<div className={isDownload ? 'p9-sm' : 'p2-sm'}>
            <span className="html2pdf__page-break" />
            {showTitle && (
               <H4 className="text-color-accent u-bold page-title-has-back sub-heading">REMEDIATION INFORMATION</H4>)
            }
          <div className="ncss-row">
            <Label className="ncss-col-sm-6 pb3-sm u-bold description">
              Has any of the affected material left the manufacturer&rsquo;s facility?
            </Label>
            <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
              {typeof qrfDetails.leftFacility !== 'undefined' ? (
                <span>{qrfDetails.leftFacility}</span>
              ) : (
                'Not Added'
              )}
            </Label>
          </div>
          <div className="ncss-row">
            <Label className="ncss-col-sm-6 pb3-sm u-bold description">
            How much material is affected by this failure?
            </Label>
            <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
              {typeof qrfDetails.quantity !== 'undefined' ? <span>{qrfDetails.quantity}</span> : 'Not Added'}
            </Label>
          </div>
          
          <div className="ncss-row">
            <Label className="ncss-col-sm-6 pb3-sm u-bold description">
            How much is the material worth?
            </Label>
            <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
              {(typeof qrfDetails.materialWorth !== 'undefined' && qrfDetails.materialWorth !== null) ? <span>{qrfDetails.materialWorth}</span> : 'Not Added'}
            </Label>
          </div>
          <div className="ncss-row">
            <Label className="ncss-col-sm-6 pb3-sm u-bold description">
            Does this material need improvement, root cause analysis, corrective actions, and retesting before it can be used in Nike products?
            </Label>
            <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
              {(typeof qrfDetails.futureProduction !== 'undefined' && qrfDetails.futureProduction !== null) ? <span>{qrfDetails.futureProduction}</span> : 'Not Added'}
            </Label>
          </div>
        {qrfDetails.futureProduction === 'Yes' && (
            <div>
                {/* Start of FRF Information */}
                
              <div className="ncss-row">
                <Label className="ncss-col-sm-6 pb3-sm u-bold description">
                Have you completed the Root Cause Analysis?
                </Label>
                <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {typeof frfDetails.PDCA !== 'undefined' ? <span>{frfDetails.PDCA}</span> : 'Not Added'}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-6 pb3-sm u-bold description"> Why was this chemical found in the material submitted for RSL testing? Please identify the raw material, chemical product, or process that may have contained this chemical.</Label>
                <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {typeof frfDetails.failureDesc !== 'undefined' ? (
                    <span>{frfDetails.failureDesc}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-6 pb3-sm u-bold description">
                Please explain your investigation and root cause findings. Why was this chemical present in the material?
                </Label>
                <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {typeof frfDetails.rootCause !== 'undefined' ? (
                    <span>{frfDetails.rootCause}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-6 pb3-sm u-bold description">
                What corrective actions have you taken, or will you take, to address the root cause of this chemical failure and improve the material before retesting?
                </Label>
                <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {typeof frfDetails.correctiveAction !== 'undefined' ? (
                    <span>{frfDetails.correctiveAction}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-6 pb3-sm u-bold description">
                Have you completed the proposed corrective action?
                </Label>
                <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {frfDetails.proposedCorrectiveAction !== '' ? (
                    <span>{frfDetails.proposedCorrectiveAction}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>
              {frfDetails.proposedCorrectiveAction === 'No' &&
              <div className="ncss-row">
                <Label className="ncss-col-sm-6 pb3-sm u-bold description">
                  What date will the corrective action be completed?
                </Label>
                <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {(frfDetails.dateOfCompletion !== '' && frfDetails.dateOfCompletion !== null) ? (
                    // <span>{frfDetails.dateOfCompletion}</span>
                     (<span>{moment.utc(frfDetails.dateOfCompletion).format('DD-MMM-YYYY')}</span>)
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>}
              {frfDetails.proposedCorrectiveAction === 'Yes' &&
              <div className="ncss-row">
                  <Label className="ncss-col-sm-6 pb3-sm u-bold attachment-sets description">
                   Attachment
                  </Label>
                  <Label className="ncss-col-sm-6 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                    {attachment && attachment.length > 0 ? <div>{attachment.map(data =>( 
                      <div>
                        <span>{data.fileName}</span>
                       { attachmentEdit && <div  className="inline-flex-display download_button" title="Download file" onClick={()=>{openConfirmationPopup(data.fileName)} }>
                          <i className="fa fa-download"></i>
                        </div>}
                      </div>))}
                    </div> : 'Not Added'}
                  </Label>
              </div>}
              <ConfirmationBox
          message={
              'Do you want to download the ' + fileName + '?'
          }
          submitModal={submitModal}
          submitValue={
             () => {
              downloadFile({id: frfDetails.frfId, fileName: fileName});
                }
          }
          closeModal={closeSubmitModal}
        />
            </div>
        )}
          </div>)
    );
};
const mapDispatchToProps = dispatch => ({
  downloadAttachment: data => {
    dispatch(createServiceAction('downloadAttachment', 'requested')(data));
  }
});

//export default Remediation;
export default (connect(null, mapDispatchToProps)(Remediation));
